import { Route } from '@angular/router';

export const campaignsRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/campaigns/create-flow'),
    data: {
      hideHeader: true,
    },
  },
  //TODO: Clean up after adam warrens changes are done
  {
    path: ':campaignCode/images',
    loadChildren: () => import('@rma/campaigns/campaign-images'),
  },
  {
    path: 'result-notification',
    loadChildren: () => import('@rma/campaigns/result-notification'),
  },
  {
    path: ':verticalType',
    children: [
      {
        path: '',
        loadComponent: () => import('@rma/campaigns/overview'),
      },
      {
        path: ':campaignCode',
        //TODO TS: add resolver here for campaign, once we work out if we need them separate
        children: [
          {
            path: 'manage-reviews',
            loadChildren: () => import('@rma/campaigns/manage-campaign-reviews'),
          },
          {
            path: 'manage-images',
            loadChildren: () => import('@rma/campaigns/campaign-images'),
          },
        ],
      },
    ],
  },
];
